'use strict';

var DashboardSummaryPanelDirective = function DashboardSummaryPanelDirective() {
  return {
    restrict: 'E',
    template: require('../templates/dashboard-summary-panel.html'),
    controller: require('../controllers/DashboardSummaryPanelController'),
    scope: {
      screenState: '=',
      monthsLabel: '=',
      selectedDataToSummary: '='
    },
    link: function link($scope) {
      $scope.$watch('selectedDataToSummary', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          $scope.recalculateSummaryPanel(newValue);
        }
      });
    }
  };
};
DashboardSummaryPanelDirective.$inject = [];
module.exports = DashboardSummaryPanelDirective;